// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".max-w-680[data-v-1bee304c]{margin-left:auto;margin-right:auto;max-width:68rem}.oimage[data-v-1bee304c] img{max-width:100%!important}@media (min-width:768px){.oimage[data-v-1bee304c] img{max-width:unset!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
